namespace Matrix.Dashboards {

    export const chartColors = ['#4dc9f6', '#f67019', '#f53794', '#537bc4', '#acc236', '#166a8f', '#00a950', '#58595b', '#8549ba'];

    // https://nagix.github.io/chartjs-plugin-colorschemes/colorchart.html
    export const modernColors10 = ['#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F', '#EDC948', '#B07AA1', '#FF9DA7', '#9C755F', '#BAB0AC'];
    export const modernColors20 = ['#4E79A7', '#A0CBE8', '#F28E2B', '#FFBE7D', '#59A14F', '#8CD17D', '#B6992D', '#F1CE63', '#499894', '#86BCB6', 
        '#E15759', '#FF9D9A', '#79706E', '#BAB0AC', '#D37295', '#FABFD2', '#B07AA1', '#D4A6C8', '#9D7660', '#D7B5A6'];
    export const classicColors20 = ['#1f77b4', '#aec7e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896',
        '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5'];

    @Serenity.Decorators.registerClass('Matrix.Dashboards.ChartWidgetDesigner')
    export class ChartWidgetDesigner implements IWidgetDesigner {
        private dialog: IWidgetDesignerDialog;

        private get series() {
            return this.dialog.getEditor("Series", ChartSeriesEditor);
        }

        private get labelField() {
            return this.dialog.getEditor("LabelField", FieldSelect);
        }

        init(dialog: IWidgetDesignerDialog) {
            this.dialog = dialog;

            this.series.updateSeries = () => this.updateSeries(true);
            this.dialog.getDatasetEditor().changeSelect2(() => this.updateSeries(false));
        }

        onLoad() {
            this.dialog?.getDatasetColumns(columns => this.updateFieldsFrom(columns));
        }

        updateSeries(merge: boolean) {
            this.dialog?.getDatasetColumns(columns => this.updateSeriesWithColumns(merge, columns));
        }

        updateSeriesWithColumns(merge: boolean, columns: Data.DataColumn[]) {
            columns = columns || [];

            this.updateFieldsFrom(columns);

            if (!this.labelField.value && this.labelField.items.length)
                this.labelField.value = this.labelField.items[0].id;

            var serieList = ChartWidget.extractSeriesFromColumns(columns);

            this.series.setValue(serieList, merge);
        }

        updateFieldsFrom(columns: Data.DataColumn[]) {
            var value = this.labelField.value;
            this.labelField.items = (columns || []).map(x => <Serenity.Select2Item>{
                id: x.Name,
                text: x.Name
            });
            this.labelField.value = null;
            this.labelField.value = value;
            this.series.fieldList = Q.deepClone(this.labelField.items);
        }

        destroy() {
            this.dialog = null;
        }
    }

    
}